import type { TopicViewpoint } from '@/mocks/topics';

interface ViewpointGridProps {
  items: TopicViewpoint[];
}

const sideStyle = (side: string) => {
  if (side === '正方') return 'bg-primary-100 text-primary-700';
  if (side === '反方') return 'bg-accent-100 text-accent-800';
  return 'bg-secondary-100 text-secondary-800';
};

export default function ViewpointGrid({ items }: ViewpointGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {items.map((v) => (
        <article key={v.title} className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5">
          <span className={`w-fit rounded-full px-3 py-1 text-xs font-medium ${sideStyle(v.side)}`}>{v.side}</span>
          <h3 className="mt-3 text-sm font-semibold text-foreground-950 md:text-base">{v.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
        </article>
      ))}
    </div>
  );
}